import { useEffect, useRef, useState } from 'react';

interface UseVisibilityObserverOptions {
  threshold?: number;
}

/**
 * Hook to detect when an element enters/exits the viewport using IntersectionObserver
 * @param options Configuration options for the observer
 * @returns Object with ref to attach to element and visibility state
 */
export const useVisibilityObserver = (options: UseVisibilityObserverOptions = {}) => {
  const { threshold = 0.1 } = options;
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [threshold]);

  return {
    elementRef,
    isVisible,
  };
};
